import { queryOptions } from '@tanstack/react-query';
import { makeMaxHostsQueryOptions } from '#api/hosts.queries.ts';
import { truncateAddress } from '#components/atoms/pill/ip-address-pill/truncateAddress.ts';
import type { Host } from '#dn-types/host.ts';
import { getIpV4, getIpV6 } from '#util/hostIps.ts';

export const NO_HOST_FLAG = 'none';

export type NoneOption = {
  value: typeof NO_HOST_FLAG;
  label: string;
  hint?: string;
};

/**
 * Fetches a list of every host in the account, 500 at a time, up to 5000 hosts.
 *
 * This is not ideal, but without a searchable endpoint from the api, this is what we need to do
 * in order to allow the user to search for a host.
 */
export function makeAllHostsQueryOptions(noneOption?: NoneOption, filterHosts: (host: Host) => boolean = () => true) {
  return queryOptions({
    ...makeMaxHostsQueryOptions(),
    select: (data) => {
      const hostItems = data.data
        .filter((element) => filterHosts(element))
        .map((host) => {
          // Join overlay IPs as a comma-separated truncated list (v6 first to match list display)
          const hint = [getIpV6(host), getIpV4(host)]
            .filter((ip): ip is string => Boolean(ip))
            .map((ip) => truncateAddress(ip))
            .join(', ');
          return { value: host.id, label: host.name, hint };
        });

      if (noneOption) {
        return {
          items: [noneOption, ...hostItems],
        };
      }

      return { items: hostItems };
    },
  });
}
